(function(){
  function init(){
    document.querySelectorAll('.footer-block.grid__item').forEach(function(block){
      var h = block.querySelector('.footer-block__heading');
      var c = block.querySelector('.footer-block__details-content');
      if(!h || !c || block.classList.contains('lv1-fcol')) return;
      block.classList.add('lv1-fcol');
      h.addEventListener('click', function(){
        if (window.innerWidth > 749) return;
        block.classList.toggle('is-open');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
